import React, { useEffect, useState } from 'react';
import { Worker, Viewer } from '@react-pdf-viewer/core';
import { defaultLayoutPlugin } from '@react-pdf-viewer/default-layout';
import '@react-pdf-viewer/core/lib/styles/index.css';
import '@react-pdf-viewer/default-layout/lib/styles/index.css';
import './FlipbookModal.css';

const FlipbookModal = ({ pdfUrl, onClose }) => {
  const [isMobile, setIsMobile] = useState(false);
  const defaultLayoutPluginInstance = defaultLayoutPlugin();
  const pluginsToUse = isMobile ? [] : [defaultLayoutPluginInstance];

  useEffect(() => {
    const updateView = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener('resize', updateView);
    updateView();
    return () => window.removeEventListener('resize', updateView);
  }, []);

  return (
    <div
      className="modal-overlay"
      onClick={onClose}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.85)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1000,
      }}
    >
      <div
        className="modal-content"
        onClick={(e) => e.stopPropagation()}
        style={{
          position: 'relative',
          backgroundColor: '#fff',
          width: '100vw',
          height: '100vh',
          padding: 0,
          overflow: 'hidden',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <button
          className="close-button"
          onClick={onClose}
          style={{
            position: 'absolute',
            top: '10px',
            right: '10px',
            backgroundColor: 'red',
            color: 'white',
            border: 'none',
            borderRadius: '4px',
            padding: '6px 12px',
            cursor: 'pointer',
            zIndex: 1100,
          }}
        >
          ✖ Close
        </button>

        <div style={{ flex: 1, overflow: 'hidden' }}>
          <Worker workerUrl="https://unpkg.com/pdfjs-dist@3.11.174/build/pdf.worker.min.js">
            <Viewer
              fileUrl={pdfUrl}
              defaultScale={isMobile ? 0.75 : 1.0}
              scrollMode="vertical"
              viewMode="single"
              plugins={pluginsToUse}
            />
          </Worker>
        </div>
      </div>
    </div>
  );
};

export default FlipbookModal;
